import { createContext, useContext } from 'react'

import type { SEARCH_STATE } from '@routes/ProductFinder/Provider'

export interface ProductFinderContext {
  searchState: SEARCH_STATE
  setSearchState: (value: SEARCH_STATE) => void
  selectedShelfId: undefined | string
  setSelectedShelfId: (value: undefined | string) => void
  selectedGTIN: undefined | string
  setSelectedGTIN: (value?: string) => Promise<void>
}

const productFinderContext = createContext<ProductFinderContext | undefined>(undefined)

export function useProductFinderContext() {
  const context = useContext(productFinderContext)

  if (context === undefined) {
    throw new Error('useProductFinderContext must be used within a ProductFinderContext')
  }

  return context
}

export default productFinderContext